<div class="content-wrap">
  <div class="row no-print">
    <h2 class="title">
      {{ "cashcut-details.title" | translate }}
    </h2>
  </div>
  <div *ngIf="cashcutDetails$ | async as cashcut" class="row">
    <app-cashcut-details-overview
      class="no-print"
      [cashcut]="cashcut"
      [language]="currentLanguage$ | async"
    ></app-cashcut-details-overview>
    <app-cashcut-details-receipt
      [cashcut]="cashcut"
    ></app-cashcut-details-receipt>
  </div>
  &nbsp;
</div>
